import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import ButtonBase from '@material-ui/core/ButtonBase';
import OverflowEllipsis from 'react-overflow-ellipsis';

import styles from './ClaimCardStyles';

const ClaimCard = props => {
  const {
    id,
    classes,
    data,
    expanded,
    handleResolveClaim,
    handleDeleteClaim,
    index
  } = props;

  if (expanded) {
    
    return (
      <Paper className={classNames(classes.claim, classes.claimExpanded)} >
        <div className={classes.claimBackground}></div>
        <ButtonBase
          className={classes.dayCounter}
          onClick={() => props.toggleExpansion(props.id)}>
          {index+1}
        </ButtonBase>
        <p className={classes.number} onClick={() => props.toggleExpansion(props.id)}><span>{data.daysPast}zi</span></p>
        
        <ButtonBase
          className={classes.description}
          onClick={() => props.toggleExpansion(id)}>
          {data.description}
        </ButtonBase>
        <p className={classes.title} onClick={() => props.toggleExpansion(props.id)}>{data.name.toUpperCase()}</p>
        <div className={classes.reason} >
          <Button variant="contained" size="small" color="default" onClick={() => props.toggleExpansion(props.id)}>
              INCHIDE
          </Button>
        </div> 
        
        <div className={classes.maternity}>
          {data.maternity &&  <p className={classes.maternityLabel}>Spital:</p>}
          <OverflowEllipsis className={classes.maternityValue}>
            {data.maternity? data.maternity.toUpperCase(): ''}
        </OverflowEllipsis> 
        </div>
        <div className={classes.doctor}>
          <p className={classes.doctorLabel}></p>
          <p className={classes.doctorValue}>
            {data.type === 'public' ? '' : ''}
          </p>
        </div>
        <div className={classes.buttons}>
          <Button
            className={classes.buttonClose}
            variant="contained"
            target="_blank"
            size="small"
            onClick={() => handleResolveClaim(id)}
            >
            <p>ACCEPTAT</p>
          </Button>
          <Button
            className={classes.buttonDelete}
            variant="contained"
            target="_blank"
            size="small"
            onClick={() => handleDeleteClaim(id)}
            >
            <p>STERGE</p>
          </Button>
          <Button
            className={classes.buttonsCall}
            variant="contained"
            target="_blank"
            size="small"
            href={`https://api.whatsapp.com/send?phone=004${data.phone}`}>
            <p>SUNA</p>
          </Button>
          <Button
            className={classes.buttonsMessage}
            variant="contained"
            color="primary"
            size = "small"
            href={`mailto:${data.email}`}>
            <p>MESAJ</p>
          </Button>
        </div>
       
        <div className={classes.date}>
          <i className={classNames('material-icons', classes.dateIcon)}>date_range</i>
          <p>{data.date}</p>
        </div>
        <div className={classes.time}>
          <i className={classNames('material-icons', classes.timeIcon)}>access_time</i>
          <p className="claim-timeValue">{data.time}</p>
        </div>
      </Paper>
    );
  } else {
    return (
      <Paper className={classes.claim} >
        <div className={classes.claimBackground}></div>
        <ButtonBase
          className={classes.dayCounter}
          onClick={() => props.toggleExpansion(props.id)}>
          {index+1}
        </ButtonBase>
        <p className={classes.number} onClick={() => props.toggleExpansion(props.id)}><span>{data.daysPast}zi</span></p>
       
         <div className={classes.reason}>
            <Button variant="contained" size="small" color="default" onClick={() => props.toggleExpansion(props.id)}>
                  DETALII
        </Button>
        </div>
        <OverflowEllipsis className={classes.title} onClick={() => props.toggleExpansion(props.id)}>
          {data.description.toUpperCase()}
        </OverflowEllipsis>
       
        <ButtonBase
          className={classes.description}
          onClick={() => props.toggleExpansion(props.id)}>
          {data.name.toUpperCase()} 
         
        </ButtonBase>
        <div className={classes.maternity} >
          {data.maternity && <p className={classes.maternityLabel}>Spital:</p>}
          <OverflowEllipsis className={classes.maternityValue}>
            {data.maternity ? data.maternity.toUpperCase() : ''}
    </OverflowEllipsis> 
        </div>
        <div className={classes.doctor}>
          <p className={classes.doctorLabel}></p>
          <p className={classes.doctorValue}>
          {data.type === 'public' ? '' : ''}
          </p>
        </div>
        <div className={classes.date}>
          <i className={classNames('material-icons', classes.dateIcon)}>date_range</i>
          <p>{data.date}</p>
        </div>
        <div className={classes.time}>
          <i className={classNames('material-icons', classes.timeIcon)}>access_time</i>
          <p>{data.time}</p>
        </div>
      </Paper>
    );
  }
};

ClaimCard.defaultProps = {
  expanded: false,
};

ClaimCard.propTypes = {
  expanded: PropTypes.bool,
  toggleExpansion: PropTypes.func.isRequired,
};

export default withStyles(styles)(ClaimCard);